module.exports = __webpack_public_path__ + "img/etoile vide.d7b2e668.png";